export const donationOptionsMandatory = [
    {
        key: "VideoHistory",
        name: "VideoHistory",
        title: "Video Viewing History",
        description: "A list of videos watched on your account and the exact time at that they were watched. Viewing history is an essential and mandatory part of any donation.",
        optionPlatform: "tiktok",
        essential: true,
        payment:"$5",
        type: "standard",
        parent: null,
        use: "The video viewing history allows us to understand what types of videos you watched and, most notably, what videos were recommended over time.",
        warning: null
    },
    {
        key: "VideoHistory",
        name: "VideoHistory",
        title: "Video Viewing History",
        description: "A list of videos watched on your account and the exact time at that they were watched. Viewing history is an essential and mandatory part of any donation.",
        optionPlatform: "youtube",
        essential: true,
        payment:"$5",
        type: "standard",
        parent: null,
        use: "The video viewing history allows us to understand what types of videos you watched and, most notably, what videos were recommended over time.",
        warning: null        
    },
    {
        key: "AdsAndTopics",
        name: "AdsAndTopics",
        title: "Ads and Topics",
        description: "A list of posts, videos, and advertisements watched on your account and the exact time at that they were watched. Viewing history is an essential and mandatory part of any donation.",
        optionPlatform: "instagram",
        essential: true,
        payment:"$2",
        type: "standard",
        parent: null,
        use: "The content viewing history allows us to understand what types of content you watched and, most notably, what types of content were recommended over time.",
        warning: null        
    },
    {
        key: "InstagramLikes",
        name: "InstagramLikes",
        title: "Likes",
        description: 'A list of posts and comments that you liked.',
        optionPlatform: "instagram",
        essential: true,
        payment:"+$2",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, 
];

export const donationOptionsText = [
    {
        key: "LikeHistory",
        name: "LikeHistory",
        title: "Like History",
        description: "A list of videos that you liked and the exact time you liked each video.",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your like history to analyze how the like history affects recommendation algorithms and whether interacting with the algorithm by liking content results in the algorithm recommending more/less extreme content.",
        warning: null
    },
    {
        key: "SearchHistory",
        name: "SearchHistory",
        title: "Search History",
        description: "A list of search terms that you searched and the exact time that the search was performed.",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your search history to infer your interests over time. Also, the search history is a signal that is likely affecting recommendations, hence we aim to understand how search queries might result in the algorithm recommending more/less extreme content.",
        warning: "This information may be sensitive if you made uncommon searches for things related to your real identity, e.g., searching for videos of a family member's small sports team."
    },
    {
        key: "SearchHistory",
        name: "SearchHistory",
        title: "Search History",
        description: "A list of search terms that you searched and the exact time that the search was performed.",
        optionPlatform: "youtube",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your search history to infer your interests over time. Also, the search history is a signal that is likely affecting recommendations, hence we aim to understand how search queries might result in the algorithm recommending more/less extreme content.",
        warning: "This information may be sensitive if you made uncommon searches for things related to your real identity, e.g., searching for videos of a family member's small sports team."
    },    
    {
        key: "ShareHistory",
        name: "ShareHistory",
        title: "Share History",
        description: "A list of videos that you shared, the exact time of the share, and the method of sharing (e.g., shared via link, email, or via messaging platforms like Facebook Messenger).",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your share history as another signal for engaging with videos. Similarly to the like history, we aim to analyze whether sharing specific videos results in more/less extreme recommendations.",
        warning: null
    },
    {
        key: "SessionHistory",
        name: "SessionHistory",
        title: "Session Times",
        description: "A list of dates and times that you opened the TikTok app and started watching videos. Note that we remove all other session specific information (e.g., IP addresses) before transferring any data to our infrastructure.",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use the session times (i.e., when the user start using the TikTok app) to divide the viewing history into sessions and make fine granular analysis on how recommendations change on a per-session basis.",
        warning: null
    },
    {
        key: "TikTokFavourites",
        name: "TikTokFavourites",
        title: "Favorites List",
        description: 'A list of hashtags, sounds, effects you marked as “favorites” in the TikTok app.',
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your favorites as another way to infer your interests over time. Inferring your interests is of paramount importance for our work, as it will allow us to assess whether the recommendation algorithm proposes content that is in-line with your interests.",
        warning: null
    },
    {
        key: "TikTokFollowing",
        name: "TikTokFollowing",
        title: "Following List",
        description: 'A list of account names that you follow along with the exact time of when the follow happened.',
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your network (i.e., who follows you and who you follow) to understand how this network is affecting video recommendations.",
        warning: "This information may be sensitive if you only follow people that you know personally, especially if those people do not have many followers."
    },
    {
        key: "TikTokFollowers",
        name: "TikTokFollowers",
        title: "Follower List",
        description: 'A list of account names that follow you along with the exact time of when the follow happened.',
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We plan to use your network (i.e., who follows you and who you follow) to understand how this network is affecting video recommendations.",
        warning: "This information may be sensitive if the number of people following you is small and consists of people you know personally."
    },
    {
        key: "Comments",
        name: "Comments",
        title: "Comments",
        description: "A list of comments that you made on videos including the time that the comment was made.",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "Your comments are yet another signal that we can use to understand user engagement on videos. We aim to assess how user comments are affecting algorithmic recommendations.",
        warning: null
    },
    {
        key: "Comments",
        name: "Comments",
        title: "Comments",
        description: "A list of comments that you made on videos including the time that the comment was made.",
        optionPlatform: "youtube",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "Your comments are yet another signal that we can use to understand user engagement on videos. We aim to assess how user comments are affecting algorithmic recommendations.",
        warning: null
    },
    {
        key: "CommentText",
        name: "CommentText",
        title: "Comment Text",
        description: "The text of the comments you made on videos.",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "secondary",
        parent: "Comments",
        use: null,
        warning: "This information may be sensitive if you made comments that can be used to identify you, such as commenting on a video posted by a relative and mentioning your relationship (e.g., 'Glad to see you enjoying your holiday, Aunt Suzie')."
    },
    {
        key: "CommentText",
        name: "CommentText",
        title: "Comment Text",
        description: "The text of the comments you made on videos.",
        optionPlatform: "youtube",
        essential: false,
        payment:"+$1",
        type: "secondary",
        parent: "Comments",
        use: null,
        warning: "This information may be sensitive if you made comments that can be used to identify you, such as commenting on a video posted by a relative and mentioning your relationship (e.g., 'Glad to see you enjoying your holiday, Aunt Suzie')."
    },
    {
        key: "AdData",
        name: "AdData",
        title: "Ads and Partner Data",
        description: "A list of advertisers that targeted you on the platform.",
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: 'We plan to investigate whether specific ad targeting is more likely to result to more extreme algorithmic recommendations.',
        warning: null
    }, {
        key: "TikTokAppSettings",
        name: "TikTokAppSettings",
        title: "App Settings",
        description: 'A list of settings that you set on yout TikTok app. E.g., interests declared in the app, comment filters, language settings, who can comment/react to/duet with their videos (does not include specific users but general categories like “friends” or “nobody”).',
        optionPlatform: "tiktok",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "We aim to investigate how specific App Settings are affecting how extreme algorithmic recommendation are. In particular, we are interested in the set of interests that the user defines when they first use their app, which is a clear signal of your interests by the time you started using the TikTok app.",
        warning: null
    }, {
        key: "YouTubeSubscriptions",
        name: "YouTubeSubscriptions",
        title: "Subscriptions",
        description: 'A list of channels that you subscribed to.',
        optionPlatform: "youtube",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: "Add use",
        warning: "This information may be sensitive if you subscribed to small channels belonging to people you know personally."
    }, {
        key: "InstagramAdsAndBusinesses",
        name: "InstagramAdsAndBusinesses",
        title: "Ads and Businesses",
        description: 'Businesses that use your information for advertisement purposes.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramYourTopics",
        name: "InstagramYourTopics",
        title: "Your Topics",
        description: 'Topics that you are interested into.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramAppsAndWebsites",
        name: "InstagramAppsAndWebsites",
        title: "Apps and Websites",
        description: 'Your activities off of Instagram.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramRecentSearches",
        name: "InstagramRecentSearches",
        title: "Recent Searches",
        description: 'A list of profiles, words, or phrases that you searched.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramLinkHistory",
        name: "InstagramLinkHistory",
        title: "Link History",
        description: 'A list of links that you opened on Instagram.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramSubscriptions",
        name: "InstagramSubscriptions",
        title: "Subscriptions",
        description: 'A list of your subscriptions.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramStoryInteractions",
        name: "InstagramStoryInteractions",
        title: "Story Interactions",
        description: 'A list of your interactions with stories.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramSaved",
        name: "InstagramSaved",
        title: "Saved",
        description: 'A list of posts that you saved.',
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    }, {
        key: "InstagramComments",
        name: "InstagramComments",
        title: "Comments",
        description: "A list of comments that you made on Instagram. To preserve your privacy, the comments texts are automatically removed.",
        optionPlatform: "instagram",
        essential: false,
        payment:"+$1",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    },
]

export const excludedOptions = [
    {
        key: "ProfileInformation",
        title: "Profile Information",
        description: "We do not collect your profile information, which include sensitive and personal identifiers like username, telephone number, email address.",
        exclusionPlatform: "all"
    },
    {
        key: "AccountStatus",
        title: "Account Status",
        description: "We do not collect data about the status of your application on your phone (e.g., app version, screen resolution, etc.)",
        exclusionPlatform: "tiktok"
    },
    {
        key: "Messages",
        title: "Messages",
        description: "We do not collect any information related to private messages sent between you and other TikTok users.",
        exclusionPlatform: "tiktok"
    },
    {
        key: "Uploads",
        title: "Uploads",
        description: "We do not collect any information about the videos that you uploaded on TikTok.",
        exclusionPlatform: "tiktok"
    },
    {
        key: "UploadsYouTube",
        title: "Uploads",
        description: "We do not collect any information about the videos that you uploaded on YouTube.",
        exclusionPlatform: "youtube"
    },
    {
        key: "PurchaseHistory",
        title: "Purchase History",
        description: "We do not collect any information about purchases made within the TikTok app.",
        exclusionPlatform: "tiktok"
    }
]